import { BaseError } from "../base/BaseError";
import pinia from "@/store";
import { useAuthStore } from "@/modules/auth/store/AuthStore";

const authStore = useAuthStore(pinia);

export class UnverifiedError extends BaseError {
  message = "يرجى تأكيد البريد الإلكتروني الخاص بك";

  dispatchError() {
    // Check if the error is about whatsapp or email or both
    if (this.data.errors.not_verified.includes("whatsapp")) {
      authStore.changePhoneVerificationDialogState(true, true);
      authStore.resendPhoneVerificationCode();
    } else if (this.data.errors.not_verified.includes("email")) {
      authStore.resendVerificationCode();
      authStore.changeEmailVerificationDialogState(true, true);
    }
  }
}
